module.exports = __webpack_public_path__ + "img/17.538ce49c.png";